"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LibUnitOptimizationItemV1Dto = void 0;
var zod_1 = require("zod");
var common_1 = require("./common");
/**
 * 유닛최적화 아이템 공통 타입
 * @see {@link https://yanolja-dev-cx-api-bucket.s3.ap-northeast-2.amazonaws.com/api-document/cx-display-api/classes/controller_widget_top_rated_product_ranking_dto_widget_v1_top_rated_product_ranking_response_dto._internal_.LibUnitOptimizationItemV1Dto.html}
 *
 * 아래 타입을 구현할때 base로 사용
 * WidgetV1ProductRecentlyResponseChipItemDto
 * CommonResponseItemDto
 * WidgetTopRatedProductRankingResponseTabItemDto
 * WidgetRecommendedProductPageResponseChipItemDto
 * WidgetRecentProductChipItemDto
 * WidgetNearbyProductSwipeChipItemDto
 * WidgetNearbyFilteredProductSwipeChipItemDto
 * WidgetExhibitionProductResponseTabItemDto
 * ListTopRatedProductRankingItemsResponseItemDto
 * */
exports.LibUnitOptimizationItemV1Dto = zod_1.z.object({
    /** 딥링크, 웹링크 */
    action: common_1.CommonResponseItemActionDto,
    /** 남은 객실 영역 */
    availableQuantity: common_1.CommonResponseItemBenefitDto.nullable(),
    /** 뱃지 영역 */
    badges: zod_1.z.array(common_1.CommonResponseItemPropertyDto),
    /** 베네핏 영역 */
    benefits: zod_1.z.array(common_1.CommonResponseItemBenefitDto),
    /** 캡션(카테고리/지역) 영역 */
    caption: common_1.CommonResponseItemCaptionDto.nullable(),
    /** 설명 영역 */
    description: common_1.CommonResponseItemPropertyDto.nullable(),
    /**
     * 썸네일 안의 할인 뱃지
     * */
    discountBadge: common_1.CommonResponseItemPropertyDto.nullable(),
    /** 정보 영역 */
    features: zod_1.z.array(common_1.CommonResponseItemPropertyDto),
    /** 고유 아이디 */
    id: zod_1.z.string(),
    /** 이미지 정보 */
    image: common_1.CommonResponseItemImageDto,
    /** 장소 영역 */
    location: common_1.CommonResponseItemPropertyDto.nullable(),
    /** 썸네일 안의 장소 영역 */
    locationDescription: common_1.CommonResponseItemPropertyDto.nullable(),
    /** 썸네일 안의 멤버십 뱃지 영역 */
    memberClassBadge: common_1.CommonResponseItemPropertyDto.nullable(),
    /** 공지 영역 */
    notices: zod_1.z.array(common_1.CommonResponseItemBenefitDto),
    /** 위경도 정보 */
    position: common_1.CommonResponseItemPositionDto.nullable(),
    /** 가격영역 */
    prices: zod_1.z.array(zod_1.z.array(common_1.CommonResponseItemPropertyDto)),
    /** 썸네일 안의 순위 영역 */
    ranking: common_1.CommonResponseItemPropertyDto.nullable(),
    /** 리뷰 영역 */
    review: common_1.CommonResponseItemReviewDto.nullable(),
    /** 제목 영역 */
    title: common_1.CommonResponseItemPropertyDto,
});
